// eslint-disable-next-line import/prefer-default-export
export const reactRoot = document.querySelector("#react-root");
